export default __webpack_public_path__ + "static/media/covid.7c150e1c.png";